import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App.tsx";
import "./index.css";
import * as Sentry from "@sentry/react";
import { BrowserRouter } from "react-router";
import { store } from "@/store/store";
import { Provider } from "react-redux";
import { Toaster } from "@/components/ui/sonner";

Sentry.init({
  dsn: "https://75c8d8fd2b1aa58d155f969945a7ebbf@o4509673198845952.ingest.de.sentry.io/4509673206841424",
  // Setting this option to true will send default PII data to Sentry.
  // For example, automatic IP address collection on events
  sendDefaultPii: true,
});

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <Provider store={store}>
      <BrowserRouter>
        <App />
      </BrowserRouter>

      <Toaster closeButton />
    </Provider>
  </React.StrictMode>
);
